import cn from 'client/utils/cn';

import React, { Component } from 'react';

import TitleAbout from 'client/components/title-about';

import './index.css';

const b = cn('section-shift-title');

interface Props {
    title: string;
    childrenFirst?: React.ReactElement | React.ReactElement[];
    childrenSecond: React.ReactElement | React.ReactElement[];
    ratios?: '28-66' | undefined;
}

export default class SectionShiftTitle extends Component<Props> {
    render() {
        const { title, childrenFirst, childrenSecond, ratios } = this.props;

        return (
            <div className={b({ ratios })}>
                <div className={b('first')}>
                    <TitleAbout title={title} />

                    {
                        childrenFirst ? childrenFirst : null
                    }
                </div>

                <div className={b('second')}>
                    {childrenSecond}
                </div>
            </div>
        );
    }
}
